export const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
  },
  out: {
    opacity: 0,
  },
}

export const VIRTUALPAGE_NAMES = {
  0: 'welcome-to-tracklib',
  1: 'what-do-you-want-to-do',
  2: 'this-is-tracklib',
  3: 'this-is-sampling',
  4: 'what-we-do',
  5: 'three-sources-of-income',
  6: 'subscription-based',
  7: 'discovery',
  8: 'licensing',
  9: 'sample-length-determination',
  10: 'three-categories-of-original-music',
  11: 'earn-more-by-delivering-more',
  12: 'artists-with-tracks-using-samples-licensed-from-tracklib',
  13: 'videos-explaining-tracklib',
  14: 'what-happens-now',
  15: 'catalog-information',
  16: 'rights-information',
  17: 'contact-information',
  18: 'review-and-submit',
  19: 'thanks-for-your-interest',
}
